import { Stack } from "@mui/material";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { ModulesTable } from "../Components/ModulesTable";
import { NewModuleButton } from "../Components/NewModuleButton";

export const ModulesPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      preTitle={t(Resources.Common.Admin)}
      title={t(Resources.Common.Modules)}
      action={<NewModuleButton />}
    >
      <Stack spacing={Spacing.L}>
        <ModulesTable />
      </Stack>
    </AuthenticatedLayout>
  );
};
